import { render, staticRenderFns } from "./EmailDomainBlacklistsTab.vue?vue&type=template&id=4b85f928&scoped=true&"
import script from "./EmailDomainBlacklistsTab.vue?vue&type=script&lang=js&"
export * from "./EmailDomainBlacklistsTab.vue?vue&type=script&lang=js&"
import style0 from "./EmailDomainBlacklistsTab.vue?vue&type=style&index=0&id=4b85f928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85f928",
  null
  
)

export default component.exports